import React from "react";
import { Button } from "@mui/material";
const CustomButton = (props) => {
  const {
    size = "",
    variant = "contained",
    name = "",
    autoFocus = false,
    color = "primary",
    startIcon = "",
    onClick,
    fullWidth,
    className = "",
    disabled = false,
    disableRipple = false,
    disableFocusRipple = false,
    disableElevation = false,
    textColor = "white",
  } = props;

  return (
    <>
      <Button
        style={{
          minWidth: 100,
          minHeight: 30,
          textTransform: "none",
          color: textColor,
        }}
        disabled={disabled}
        className={className}
        size={size}
        color={color}
        variant={variant}
        autoFocus={autoFocus}
        startIcon={startIcon}
        onClick={onClick}
        fullWidth={fullWidth}
        disableRipple={disableRipple}
        disableFocusRipple={disableFocusRipple}
        disableElevation={disableElevation}
        {...props}
      >
        {name}
      </Button>
    </>
  );
};
export default CustomButton;
